import React, { useEffect, useState } from 'react';
import AddToSelection from './AddToSelection';
import { v4 as uuidv4 } from 'uuid';
import Misc from './common/Misc.svg';

import AvailableProductInfo from './AvailableProductInfo';

import { AvailableProduct, AvailableProductImgFrame } from '../styles';

const AvailableProducts = ({
  products,
  handleAddItem,
  selection,
  updateItemAdd,
  updateItemRemove,
}) => {
  const [focusedProduct, setFocusedProduct] = useState(null);

  // useEffect(() => {
  //   if (focusedProduct) {
  //     console.log('product is now focused');

  //   }
  // }, [focusedProduct])

  const handleProductFocus = (productData) => {
    if (!focusedProduct || focusedProduct.variantID !== productData.variantID) {
      setFocusedProduct(productData);
    }
  };

  return (
    <>
      <div className="row my-3">
        {products.products.map((product, i) => {
          return (
            <AvailableProduct
              key={uuidv4()}
              className={`col-sm-4 col-6 py-1 my-2`}
            >
              <AvailableProductImgFrame
                onClick={() => handleProductFocus(product)}
                className={
                  focusedProduct?.variantID === product.variantID
                    ? 'focused'
                    : ''
                }
              >
                {Misc.ProductInfoBtn}
                <img
                  src={`https:${product.img}`}
                  alt={`${product.frontend_title} image`}
                />
              </AvailableProductImgFrame>
              <div className="cupcake-selector__available-product--price-title">
                {product.personalisation_available === 'Y' && (
                  <span>*Can be personalised*</span>
                )}
                <span className="available-product__price-title">
                  {product.frontend_title}
                </span>
              </div>

              <AddToSelection
                product={product}
                handleAddItem={handleAddItem}
                selection={selection}
                updateItemAdd={updateItemAdd}
                updateItemRemove={updateItemRemove}
              />
            </AvailableProduct>
          );
        })}
        {focusedProduct && (
          <AvailableProductInfo
            product={focusedProduct}
            setFocusedProduct={setFocusedProduct}
            focusedProduct={focusedProduct}
            handleAddItem={handleAddItem}
            selection={selection}
            updateItemAdd={updateItemAdd}
            updateItemRemove={updateItemRemove}
          />
        )}
      </div>
    </>
  );
};

export default AvailableProducts;
